<template>
  <div class="content Tabs">

     <b-tabs card>

          <b-tab :title="lang.tab_ImportBom"  :title-link-class="textColors" :title-item-class="textColors" active >
            <b-container class="bv-example-row">

              <b-form class="file-form">
                <p>{{lang.label_file}}:</p>
                <br>
                <b-row>
                  
                  <b-col cols="5">
                    <b-form-file
                      v-model="file"
                      :state="Boolean(file)"
                      :placeholder= lang.placeholder_file
                      drop-placeholder= lang.placeholder_file
                      class="import-file"
                      accept=".LST"
                      size="sm"
                      

                    ></b-form-file>
                  </b-col>
                  <b-col cols="2">
                    <b-button @click="uploadFile" class="upload-form-button" size="sm" :variant="variant">{{lang.button_Upload}}</b-button>

                  </b-col>
                </b-row>
                
                  
              </b-form>
             
              
            </b-container>
          </b-tab>


        </b-tabs>



  </div>

</template>
<script>
import { mapGetters } from 'vuex'




import MappingBomTableComponent from '@/components/shared/MappingBomTableComponent'

export default {
  name: "Content",
  components: {
    
    MappingBomTableComponent

  },
  props:{
    lang: Object,

  },
  data () {
    return {
      file: null,
      isProps: false,
      name: "",
      description: "",
      delimiterOptions: [
        { value: ",", text: ',' },
        { value: ';', text: ';' },
        { value: 'tab', text: '{Tab}' },

      ],
      delimiter: ",",
      variantsOptions: [],
      
    }
  },
  computed: {
    ...mapGetters({
      

    }),
    lastRevisionHistory() {
      if (this.$store.getters.revisionHistory == null) {
        return
      }
      let tab = this.$store.getters.revisionHistory;
      let obj = tab[0];
      for (let i = 0, lei = tab.length; i < lei; i++) {

        if (tab[i].revision > obj.revision) {
          obj = tab[i];
        }
      }

      return obj;
    },
    revisionId() {
      if (this.lastRevisionHistory == undefined) {
        return
      }
      return this.lastRevisionHistory.id;
        // if (this.$store.getters.selectedRows[0].col___revisionId.revisionId == undefined){
        //     return ""
        // }
        // return this.$store.getters.selectedRows[0].col___revisionId.revisionId;
    },
    objDescription(){
      
      return this.description;
    },
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    variant(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "light";
      }else{
        return "dark";
      }
      
    }
  },
  created () {
    this.getVariants();

  },

  updated() {
    

    const obj = {
      description: this.description,
      name: this.name
    }
    this.$store.dispatch(this.$store.getters.sectionPrefix + "_setBomDescription", obj)
  },
  watch: {
    
    delimiter: function (newVal, oldVal){
      
      this.$parent.$parent.$parent.setSeparator(newVal);
      if (this.file != null) {
        this.uploadFile();
      }
    }
  },
  methods:{
    getVariants(){

      this.variantsOptions = [];

      const variants = this.$store.getters.variants;

      for (let i = 0, lei = variants.length; i < lei; i++){

    

        let obj = {
          value: variants[i].name, 
          text: variants[i].name,
          
        }
        this.variantsOptions.push(obj);
      }

      if (this.variantsOptions.length == 0){
        let obj = {
          value: "No variant", 
          text: "No variant",
          
        }
        this.variantsOptions.push(obj);
      }

      
    },
    uploadFile(){
      

      let _vue = this;

      let obj = {
        file:{
          file: this.file,
        },
        
        projectRevisionId: this.revisionId,
        
      }
console.log(obj)
      this.$store.dispatch("showLoader", { visible: true, text: "load" });

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_importBomLst", obj)
        .then(function (result) {

          console.log(result)



          if (result.status == "OK") {

            if (result.data == 1) {
              _vue.imported = true;

              _vue.$store.dispatch("showLoader", { visible: false });

              let obj = {
                text: _vue.lang.alert_success_import,
                time: 5,
                type: "success"
              }

              _vue.$store.dispatch("displayFooterAlert", obj)

              //_vue.$store.dispatch(_vue.$store.getters.sectionPrefix +"_resetMapField");

              const reloadObj = {
                status: true,
                name: "BomsProjectTableComponent"
              }
              _vue.$store.dispatch("reloadAfterActionComplex", reloadObj);


              _vue.back();
            } else {
              let obj = {
                text: _vue.lang.alert_error_import + ".",
                time: 10,
                type: "danger"
              }

              _vue.$store.dispatch("displayFooterAlert", obj)
            }

            

          } else {

            let obj = {
              text: _vue.lang.alert_error_import + ": " + result.message,
              time: 10,
              type: "danger"
            }

            _vue.$store.dispatch("displayFooterAlert", obj)


          }


        })
        .then(function () {
console.log("tu2")
          _vue.$store.dispatch("showLoader", { visible: false });

        })

    },
    back() {


      let to = this.$route.query.from;




      const query = {
        from: this.$route.path,
        to: to,
        projectId: this.$route.query.projectId,
        tabIndex: 1
      }

      this.$router.push({ path: to, query: query });

    },

  },
  
}
</script>

<style lang="scss">

  .Tabs{
    .bv-example-row-max{
      max-width: 100%;
      padding-right: 0px;
      padding-left: 0px;
    }

    .file-form{
      width: 80%;
    }

    .upload-form-button{

      margin-left: 10px;
      margin-top: 2px;
    }
    .textarea-descr{
      margin-top: 2px;
    }
    .container{
      margin-left: 10px !important;
    }
    .select-variant{
      width: 300px;
    }
  }




</style>



// WEBPACK FOOTER //
// src/components/ProjectManager/Views/ProjectImportBomLst/Middle/Content/Content.vue